/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileAac = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M20.762 11.887c.244 0 .47.025.677.076.206.05.388.115.544.193v.911a4.279 4.279 0 0 0-.634-.193 2.478 2.478 0 0 0-.511-.056c-.474 0-.838.14-1.09.421s-.38.68-.38 1.195c0 .556.124.986.372 1.29.249.299.615.448 1.098.448.193 0 .388-.02.586-.062a6.48 6.48 0 0 0 .697-.207v.897c-.18.083-.389.152-.628.207a3.14 3.14 0 0 1-.78.09c-.804 0-1.414-.229-1.828-.684-.414-.46-.621-1.12-.621-1.98 0-.528.101-.982.303-1.359.203-.381.49-.674.863-.877.372-.207.817-.31 1.332-.31zM12.94 17h-1.2l-.332-1.028h-1.85L9.228 17H8.077l1.904-5.017h1.042zm-3.092-1.938h1.266l-.636-1.972zM18.035 17h-1.201l-.332-1.028h-1.85L14.321 17H13.17l1.904-5.017h1.042zm-3.094-1.938h1.267l-.637-1.972z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileAac as FileAac };
